const matchList = {
    //公共参数对应
    cpKey: '同步cpkey',
    cpUrl: '	cp充值回调地址',
    createTime: '创建时间',
    updateTime: '更新时间',
    language: '语言',
    name: '产品名称',

    //父产品参数对应
    cpCompany: 'cp公司',
    srceen: '横竖屏',
    productType: '产品类型', //1:h5 2:app 3:马甲
    gameType: '游戏大类', //1:网游 2:单机 3:小游戏
    type: '游戏类型', //卡牌，arpg，slg等
    signdCompany: '签约公司',
    department: '发行部门',
    pm: '项目负责人',

    //子产品参数对应
    pubTeam: '主体公司',
    packageName: '包名',
    uiColor: 'ui颜色',
    clientOs: '操作系统', //1:Android 2:ios
    stateArea: '地区', //1:中国大陆 2：海外
    edition: '版署包', //(0：否 1：是)
    sandbox: '沙箱包', //(0：否 1：是)


    //配置参数对应
    //登录注册
    mainLoginMethod: '主登陆方式',
    loginMethods: '登陆方式列表，数据格式',
    wechatAppId: '微信应用Id',
    wechatAppSecret: '微信应用秘钥',
    wechatLink: '微信跳转链接',
    qqAppId: 'QQ应用Id',
    qqLink: 'QQ跳转链接',
    openVerifyCodeLoginVerify: '验证码登录校验',
    openVisitorLoginVerify: '游客登录校验',
    openRegisterVerify: '注册校验',
    openRegisterPasswordVerify: '用户注册密码校验',
    openLoginActivationCode: '登录激活码',
    openPhoneBindReminders: '手机绑定提醒',

    //服务器
    defaultLanguage: '默认语言',
    serverEnvironment: '服务器环境', //集团，静思，海外，有乐等等

    //用户中心
    showBindMobile: '绑定手机',
    showChangeBindMobile: '手机换绑',
    showRealNameAuth: '实名认证',
    showHelpCenter: '联系客服',
    showPrivacy: '隐私协议',

    //隐私协议
    showLoginAgreement: '界面展示',
    clickAgreement: '默认状态',
    showOneKeyAgreement: '一键登录界面展示',
    showAgreement: '首次登录',

    //防沉迷
    openGameTimeLimitType: '时长计算',
    chargeLimitType: '支付计算',
    openLoginRealName: '登录实名',
    openChargeRealName: '支付实名',
    idCardVerifyType: '验证方式',
    openManMachine: '实名认证校验',
    noAuthLimitGameType: '时长限制',
    openChargeLimit: '支付功能',
    openPreTipsGame: '时长提醒',
    minorLimitGameType: '时长限制',
    openMinorAntiAddictionTime: '时段限制',
    openChargeLimitByAge: '支付限制',
    showFloatInterval: '实名浮窗间隔',
    reportingInterval: '时长上报间隔时间',
    preTipsGameTime: '预提醒时间',
    minorAntiAddictionTime: '禁止游戏时间',

    openNppaVerify: '中宣部实名校验',
    nppaAppId: '国家防沉迷应用ID',
    nppaBizId: '国家防沉迷备案识别码',
    nppaSecretKey: '国家防沉迷签名键',

    realNamePageUrl: '实名认证页面地址',
    noAuthLimitGameTime: '未实名防沉迷游戏时长',
    minorLimitGameTime: '非节假日游戏时长',
    minorHolidayLimitGameTime: '节假日游戏时长',



    //数据上报
    openHotCloud: '热云开关',
    hotCloudAppkey: '热云Appkey',
    hotCloudInterfaceAddress: '热云数据上报接口地址',
    syncHotCloudProducts: '是否同步数据给热云平台其他产品',
    openToutiao: '头条开关',
    toutiaoAppId: '头条Appid',
    toutiaoName: '头条Appname',
    toutiaoAppkey: '头条Appkey',
    openToutiaoSkipFirstRecharge: '头条是否跳过用户首充上报',
    openGuangdiantong: '广点通开关',
    guangdiantongAppid: '广点通Appid',
    guangdiantongReturns: '广点通数据上报概率',

    openFirstRecharge: '首次充值开关',
    openDayNewAddUserRechargeReport: '当日新增用户充值上报开关',
    reportLimitAmount: '上报限制金额',
    reportUniformAmount: '上报统一金额',

    //计费点参数对应
    productPackageId: "产品包ID",
    payAccountId: "支付账户ID",
    payMappingId: "产品包和支付账户关联ID",
    feepointIdExt: "计费点描述",
    desc: '计费点描述',
    payAppId: "支付应用ID", //(用于谷歌和苹果支付)
    price: "价格/单位分",
    currency: "货币",
    currencyLimit: "货币限制",
    described: "描述",
    subscribe: "是否订阅",
    safetyCurrency: '兜底币种',
    billPrice: '对账价格/单位分',
    billCurrency: '对账币种',
    channelProductId: '三方计费点(苹果和谷歌等)',

    //支付账号参数对应
    partner: "支付合作id,商户id",
    appId: "应用ID",
    payType: "支付类型", //1支付宝 2微信 3ios 4谷歌
    pubTeam: "主体",
    publicKey: "支付平台公钥", //(签名校验使用)，sign_type只有单一key时public_key与private_key相等，比如sign_type=MD5(友店支付除外)的情况
    privateKey: "应用私钥",
    domainUrl: "域名URL",
    notifyUrl: "异步回调地址",
    returnUrl: "同步回调地址",
    seller: "收款账号", //针对支付宝
    signType: "签名类型", //签名类型,阿里（RSA，RSA2），微信（MD5）


}

const faceMatch = {
    name: '弹窗名称',
        allowCloseSwitch: '弹窗是否可关闭',
        time: '生效时间',
        location: '弹出位置',
        sendScopeType: '发送条件',
        showRule: '展示次数',
        priority: '优先级',
        timeZone: '生效时段',
        status: '是否上线'
}

export function matchFace(key) {
    return faceMatch[key] || key
}
export function matchFun(key) {
    return matchList[key] || key;
}


// WEBPACK FOOTER //
// ./src/utils/matching.js